"use server";

/**
 * Returns the list of social auth providers that are enabled via env vars.
 * Replaces the next-auth `getProviders()` client call.
 */
export async function getAvailableProviders(): Promise<
    { id: string; name: string }[]
> {
    const providers: { id: string; name: string }[] = [];

    if (
        process.env.GOOGLE_ENABLED === "true" &&
        process.env.GOOGLE_CLIENT_ID &&
        process.env.GOOGLE_CLIENT_SECRET
    ) {
        providers.push({ id: "google", name: "Google" });
    }

    if (
        process.env.FACEBOOK_ENABLED === "true" &&
        process.env.FACEBOOK_CLIENT_ID &&
        process.env.FACEBOOK_CLIENT_SECRET
    ) {
        providers.push({ id: "facebook", name: "Facebook" });
    }

    if (
        process.env.APPLE_ENABLED === "true" &&
        process.env.APPLE_ID &&
        process.env.APPLE_SECRET
    ) {
        providers.push({ id: "apple", name: "Apple" });
    }

    return providers;
}
